import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  InitializeAddOrgFunctionsContract,
  InitializeAddOrgFunctionsRequest,
  InitializeAddOrgFunctionsResponse
} from '@bliks-io/contracts';
import { apiClient } from '../client';
import { invalidateEntity } from '../cache-invalidation';
import { organizationKeys } from '../query-keys';

export function useInitializeOrgFunctions() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: InitializeAddOrgFunctionsRequest) => {
      const { data: response } = await apiClient.post<InitializeAddOrgFunctionsResponse>(
        InitializeAddOrgFunctionsContract.path,
        data
      );
      return response;
    },
    onSuccess: () =>
      // Awaited (returned) on purpose: the wizard back-fills entityIds for
      // silently created functions from the refetched list — the classify
      // after mutateAsync must see it.
      Promise.all([
        invalidateEntity(queryClient, 'orgFunction'),
        // Memberships land in users' secondaryRoles.
        invalidateEntity(queryClient, 'orgMember'),
        // First import stamps initialization.orgFunctions on the organization.
        queryClient.invalidateQueries({ queryKey: organizationKeys.all })
      ])
  });
}
